import { Controller } from 'stimulus'

export default class extends Controller {
    static targets = ['one', 'other', 'trigger']

    connect() {
        if (this.hasTriggerTarget) {
            this.toggle()
        }
    }

    toggle() {
        if (this.triggerTarget.checked) {
            this.oneTarget.classList.add('d-none')
            this.oneTarget.classList.remove('d-block')

            this.otherTarget.classList.add('d-block')
            this.otherTarget.classList
        } else {
            this.oneTarget.classList.add('d-block')
            this.oneTarget.classList.remove('d-none')

            this.otherTarget.classList.add('d-none')
            this.otherTarget.classList.remove('d-block')
        }
    }
}
